import React from "react";

//UI Material
import { CircularProgress, Stack, Typography } from "@mui/material";

export default function DataLoader() {
  return (
    <Stack justifyContent="center" alignItems="center" spacing={1} textAlign="center">
      <CircularProgress />
      <Typography variant="h7" fontWeight="bold">
        Cargando información...
      </Typography>
    </Stack>
  );
}
